import { Component, EventEmitter, Input, OnChanges, Output, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { from, of } from 'rxjs';
import { catchError, mergeMap, toArray } from 'rxjs/operators';
import { Bar, BarManagementService } from 'src/app/api/api-bar-management.service.generated';
import { LocationFilterByOutlet } from 'src/app/api/api-campaigns.service.generated';
import { ConfirmDialogModel } from 'wecheer-common';

@Component({
  selector: 'app-filter-by-outlet',
  templateUrl: './filter-by-outlet.component.html',
  styleUrls: ['./filter-by-outlet.component.scss'],
  imports: [
    MatIconModule
  ]
})
export class FilterByOutletComponent implements OnChanges {
  private dialog = inject(MatDialog);
  private bmApi = inject(BarManagementService);


  @Input() model: LocationFilterByOutlet;
  @Output() deleteOutlet = new EventEmitter<string>();

  outlets: Bar[];

  ngOnChanges(): void {
    if (!this.model) return;
    this.refresh();
  }

  async refresh() {
    from(this.model.outletIds).pipe(
      mergeMap(id => this.bmApi.getById(parseInt(id)).pipe(catchError(() => of(null))), 4),
      toArray(),
    ).subscribe(res => {
      this.outlets = res;
    });
  }

  async onDelete(outlet: Bar) {
    const confirmResult = await new ConfirmDialogModel('Are you sure you want to delete this outlet?').show(this.dialog);
    if (!confirmResult) return;
    const id = outlet.id.toString();
    this.deleteOutlet.emit(id);
  }
}
